(function ($) {

    /**
     * Video
     */
    function initVideo() {
        const $rebirdVideo = $("#rebirdVideo");
        const $rebirdVideoSource = $("#rebirdVideoSource");

        const playVideo = function() {
            $rebirdVideo[0].muted = true;
            $rebirdVideo[0].load();
            $rebirdVideo[0].play();
        }

        let videoType = undefined;
        const changeIdNeeded = function () {
            if (window.innerWidth <= 768) {
                if(videoType === undefined || videoType !== "mobile") {
                    videoType = "mobile";
                    $rebirdVideo.attr("poster", "//arcteryx.jp/cdn/shop/t/244/assets/rebird-video-poster_small.jpg?v=86541670685919048541771545781");
                    $rebirdVideoSource.attr("src", "//arcteryx.jp/cdn/shop/t/244/assets/rebird-video.mp4?v=142523135723282818021771545781");
                    playVideo();
                }
            } else {
                if(videoType === undefined || videoType !== "desktop") {
                    videoType = "desktop";
                    $rebirdVideo.attr("poster", "//arcteryx.jp/cdn/shop/t/244/assets/rebird-video-poster-pc_small.jpg?v=165184224493615872681771545780");
                    $rebirdVideoSource.attr("src", "//arcteryx.jp/cdn/shop/t/244/assets/rebird-video-pc.mp4?v=19730987436238415841771545783");
                    playVideo();
                }
            }
        }

        $(window).on("resize", function() {
            changeIdNeeded();
        });
        changeIdNeeded();
    }
    initVideo();

    
    /**
     * ページ更新
     */
    function updatePage() {
        const ACTIVE_CLASS = "active";
        const locationHref = window.location.href;

        const $rebirdSubTab = $("#rebirdSubTab");
        $rebirdSubTab.removeClass(ACTIVE_CLASS);
        $(".rebird__tab a").removeClass(ACTIVE_CLASS);
        $(".rebird__sub-tab a").removeClass(ACTIVE_CLASS);
        $(".rebird__sub-tab-content").removeClass(ACTIVE_CLASS);
        $(".rebird__detail-content").removeClass(ACTIVE_CLASS);

        // WASH + DRY
        if(locationHref.indexOf("wash-dry-") !== -1) {
            $rebirdSubTab.addClass(ACTIVE_CLASS);
            $("#rebirdTabCare").addClass(ACTIVE_CLASS);
            $("#rebirdSubTabWashDry").addClass(ACTIVE_CLASS);
            $("#washDry").addClass(ACTIVE_CLASS);

            if (locationHref.indexOf("gore-tex") !== -1) {
                $("#washDryGoreTex").addClass(ACTIVE_CLASS);
            } else if (locationHref.indexOf("down") !== -1) {
                $("#washDryDown").addClass(ACTIVE_CLASS);
            } else if (locationHref.indexOf("synthetic-insulation") !== -1) {
                $("#washDrySyntheticInsulation").addClass(ACTIVE_CLASS);
            } else if (locationHref.indexOf("everything-else") !== -1) {
                $("#washDryEverythingElse").addClass(ACTIVE_CLASS);
            }
        }

        // PROTECT
        if(locationHref.indexOf("protect-") !== -1) {
            $rebirdSubTab.addClass(ACTIVE_CLASS);
            $("#rebirdTabCare").addClass(ACTIVE_CLASS);
            $("#rebirdSubTabProtect").addClass(ACTIVE_CLASS);
            $("#protect").addClass(ACTIVE_CLASS);

            if (locationHref.indexOf("gore-tex") !== -1) {
                $("#protectGoreTex").addClass(ACTIVE_CLASS);
            } else if (locationHref.indexOf("down") !== -1) {
                $("#protectDown").addClass(ACTIVE_CLASS);
            } else if (locationHref.indexOf("synthetic-insulation") !== -1) {
                $("#protectSyntheticInsulation").addClass(ACTIVE_CLASS);
            } else if (locationHref.indexOf("everything-else") !== -1) {
                $("#protectEverythingElse").addClass(ACTIVE_CLASS);
            }
        }

        // STAIN REMOVAL
        if(locationHref.indexOf("stain-removal") !== -1) {
            $rebirdSubTab.addClass(ACTIVE_CLASS);
            $("#rebirdTabCare").addClass(ACTIVE_CLASS);
            $("#rebirdSubTabStain").addClass(ACTIVE_CLASS);
            $("#stainRemoval").addClass(ACTIVE_CLASS);
            $("#stainRemovalContent").addClass(ACTIVE_CLASS);
        }

        // CARE
        if(locationHref.indexOf("product-repair") !== -1) {
            $("#rebirdTabRepair").addClass(ACTIVE_CLASS);
            $("#repair").addClass(ACTIVE_CLASS);
        }

        // STORES
        if(locationHref.indexOf("rebird-stories") !== -1) {
            $("#rebirdTabStories").addClass(ACTIVE_CLASS);
            $("#rebirdStories").addClass(ACTIVE_CLASS);
        }
    }
    updatePage();


    /**
     * タブ
     */
    function initTab() {
        $("#rebirdTab a").each(function (_, elem) {
            const $elem = $(elem);
            const href = $elem.data("href");

            $elem.on("click", function(e) {
                e.preventDefault();

                history.replaceState(null, '', href);
                updatePage();
            });
        });
    }
    initTab();


    /**
     * サブタブ
     */
    function initSubTab() {
        $("#rebirdSubTab a").each(function (_, elem) {
            const $elem = $(elem);
            const href = $elem.data("href");

            $elem.on("click", function(e) {
                e.preventDefault();

                history.replaceState(null, '', href);
                updatePage();
            });
        });
    }
    initSubTab();


    /**
     * Wash dryスワイパー
     */
    function initWashDrySwiper() {
        const washDrySwiper = new Swiper(".wash-dry__swiper", {
            slidesPerView: 2,
            centeredSlides: true,
            loop: true,
            navigation: {
                nextEl: '.wash-dry__swiper .swiper-button-next',
                prevEl: '.wash-dry__swiper .swiper-button-prev'
            },
            breakpoints: {
                769: {
                    slidesPerView: 4,
                    centeredSlides: false,
                    spaceBetween: 30
                }
            }
        });

        const $swiperSlides = $('.wash-dry__swiper .swiper-slide');
        $swiperSlides.on('click', function() {
            if (window.innerWidth >= 769) {
                $swiperSlides.removeClass('swiper-slide-active');
                $(this).addClass('swiper-slide-active');
            }
        });

        $swiperSlides.each(function() {
            const targetNode = this;
            const observer = new MutationObserver(function(mutationsList) {
                mutationsList.forEach(function(mutation) {
                    const $targetNode = $(targetNode);
                    if (
                        mutation.type === 'attributes' &&
                        mutation.attributeName === 'class' &&
                        $(targetNode).hasClass('swiper-slide-active')
                    ) {
                        const href = $targetNode.data('href');
                        const locationHref = window.location.href;

                        if (href && locationHref.indexOf(href) === -1) {
                            history.replaceState(null, '', href);
                            updatePage();
                        }
                    }
                });
            });
            observer.observe(targetNode, { attributes: true });
        });
    }
    initWashDrySwiper();


    /**
     * How to スワイパー
     */
    function initHowToSwipers() {
        [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15].forEach(function (num) {
            const howToSwiper = new Swiper(".wash-dry__how-to-swiper.swiper" + num, {
                slidesPerView: 1,
                loop: true,
                navigation: {
                    nextEl: ".swiper-button-next.swiper" + num,
                    prevEl: ".swiper-button-prev.swiper" + num
                },
                pagination: {
                    el: ".swiper-pagination.swiper" + num
                }
            });
        });
    }
    initHowToSwipers();

    /**
     * Youtubeポップアップ
     */
    function initYoutubePopup() {
        const $body = $("body");

        $(".popup-contents").each(function(_ ,elem) {
            const $elem = $(elem);
            const popupId = $elem.data("popup-id");
            const content = $elem.html();
            const $content = $(content);
            $content.attr("id", popupId);

            const youtubeId = popupId + "Youtube";
            $content.find("iframe").attr("id", youtubeId);

            $content.find("[data-micromodal-close]").on("click", function () {
                const youtubeWindow = $("#" + youtubeId)[0].contentWindow;
                youtubeWindow.postMessage('{"event":"command", "func":"pauseVideo"}', "*");
            });

            $body.append($content);
        });

        MicroModal.init();
    }
    initYoutubePopup();

    /**
     * Serviceスワイパー
     */
    function initFreeServiceSwiper() {
        const freeServiceSwiper = new Swiper(".rebird__service-swiper.free", {
            slidesPerView: 1,
            loop: true,
            navigation: {
                nextEl: '.swiper-button-next.free',
                prevEl: '.swiper-button-prev.free'
            },
            pagination: {
                el: ".swiper-pagination.free"
            }
        });
    }
    initFreeServiceSwiper();

    function initPaidServiceSwiper() {
        const paidServiceSwiper = new Swiper(".rebird__service-swiper.paid", {
            slidesPerView: 1,
            loop: true,
            navigation: {
                nextEl: '.swiper-button-next.paid',
                prevEl: '.swiper-button-prev.paid'
            },
            pagination: {
                el: ".swiper-pagination.paid"
            }
        });
    }
    initPaidServiceSwiper();

    function initRepairServiceSwiper() {
        const repairServiceSwiper = new Swiper(".rebird__service-swiper.repair", {
            slidesPerView: 1,
            loop: true,
            navigation: {
                nextEl: '.swiper-button-next.repair',
                prevEl: '.swiper-button-prev.repair'
            },
            pagination: {
                el: ".swiper-pagination.repair"
            }
        });
    }
    initRepairServiceSwiper();


    /**
     * RePAIR BASIC CONCEPT スワイパー
     */
    function initRePairBasicConceptSwiper() {
        const rePairBasicConceptSwiper = new Swiper(".basic-concept__swiper", {
            slidesPerView: 1,
            loop: true,
            navigation: {
                nextEl: '.swiper-button-next.basic-concept__swiper-arrow',
                prevEl: '.swiper-button-prev.basic-concept__swiper-arrow'
            },
            pagination: {
                el: ".basic-concept__swiper-pagination"
            },
            breakpoints: {
                769: {
                    slidesPerView: 3,
                    spaceBetween: 30
                }
            }
        });
    }
    initRePairBasicConceptSwiper();

    /**
     * 修理例 スワイパー
     */
    function initSewingSwipers() {
        [1, 2, 3, 4, 5].forEach(function (num) {
            const sewingSwipers = new Swiper(".sewing-example__swiper.sewing" + num, {
                slidesPerView: 1,
                loop: true,
                navigation: {
                    nextEl: ".swiper-button-next.sewing" + num,
                    prevEl: ".swiper-button-prev.sewing" + num
                },
                breakpoints: {
                    769: {
                        slidesPerView: 2
                    }
                }
            });
        });
    }
    initSewingSwipers();

    /**
     * 共通アコーディオン
     */
    function initRebirdAccordions() {
        $(".rebird-accordion").each(function (_, elem) {
            const $elem = $(elem);
            $elem.find(".rebird-accordion__switch").on("click", function () {
                $elem.find(".rebird-accordion__content").slideToggle();
            });
        });
    }
    initRebirdAccordions();

})(jQuery)